import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
var BREAKPOINT = 399; // px
var CLIENT_ID = '937917521719-79ju159majq0j9crrl7dtp6v8vhbva1g.apps.googleusercontent.com';
export var GoogleAuth = function (_a) {
    var handleSuccess = _a.handleSuccess;
    var btn = useRef(null);
    useEffect(function () {
        function handleCredentialResponse(response) {
            handleSuccess(response.credential);
        }
        var innerWidth = window.innerWidth;
        var isMobileVersion = innerWidth < BREAKPOINT;
        if (btn.current && window.google) {
            window.google.accounts.id.initialize({
                client_id: CLIENT_ID,
                callback: handleCredentialResponse,
            });
            window.google.accounts.id.renderButton(btn.current, {
                theme: 'outline',
                size: 'large',
                text: 'Sign in with Google',
                // @todo: Hardcode
                width: 400 - (isMobileVersion ? 120 : 64),
                logo_alignment: 'center',
            });
        }
    }, [btn, handleSuccess]);
    return _jsx("div", { style: { marginTop: 12 }, ref: btn });
};
